module.exports = __webpack_public_path__ + "img/ham_lane.f5fc503e.png";